import { render, staticRenderFns } from "./editPriceLabel.vue?vue&type=template&id=48376740&scoped=true"
import script from "./editPriceLabel.vue?vue&type=script&lang=js"
export * from "./editPriceLabel.vue?vue&type=script&lang=js"
import style0 from "./editPriceLabel.vue?vue&type=style&index=0&id=48376740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48376740",
  null
  
)

export default component.exports